<template>
  <div class="base-nav-primary">
    <div class="content">
      <div class="navigation">
        <template v-for="link in links">
          <router-link class="link" :to="link.path" :key="link.path" v-if="link.authorized">{{ link.title }}</router-link>
        </template>
      </div>
      <div class="logo"></div>
    </div>
  </div>
</template>

<script>
import { createLinks } from '@/router/router'
export default {
  computed: {
    links() {
      return createLinks(['/welcome', '/widget', '/account', '/help'])
    }
  }
}
</script>

<style lang="scss" scoped>
.base-nav-primary {
  width: 100%;
  background: var(--color-white-1);
  display: flex;
  justify-content: center;
  padding: 2.5rem var(--spacing-5);
  border-bottom: var(--border-1);
  position: relative;
  z-index: 1;
  @include media(sm-down) {
    padding: 2.5rem var(--spacing-4);
  }
}
.base-nav-primary * {
  color: var(--color-gray-3);
  font-weight: var(--fw-medium);
  pointer-events: none;
}
.content {
  width: 100%;
  display: flex;
  max-width: var(--width-1);
  justify-content: space-between;
}
.link {
  position: relative;
  pointer-events: all;
  &::after {
    content: '';
    position: absolute;
    width: calc(100% + 1.5rem * 2);
    height: calc(100% + 0.6rem * 2);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: var(--color-gray-2);
    border-radius: 3px;
    z-index: -1;
    opacity: 0;
  }
  &.router-link-active {
    color: var(--color-black-1);
    &::after {
      opacity: 1;
    }
  }
  &:not(:last-child) {
    margin-right: var(--spacing-5);
  }
}
.logo {
  font-style: italic;
}
</style>
